module.exports = "/images/recruit.png?07e760284fabfd8565005a4d9192395d";